module.exports = "<!-- <public-header></public-header>\r\n<div id=\"wrapper\" class=\"public-wrapper-content\">\r\n  <main class=\"container\">\r\n    <router-outlet></router-outlet>\r\n  </main>\r\n</div> -->\r\n\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/public/public.section.layout.html
// module id = ../../../../../src/app/public/public.section.layout.html
// module chunks = main